import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Constants } from '../constants';

@Directive({
  selector: '[appAlphabetOnly]'
})
export class AlphabetOnlyDirective {
  @Input() pattern: string;
  constructor(private element: ElementRef, private control: NgControl) { }
  @HostListener('input', ['$event']) onKeyDown(event) {
    const initalValue = this.element.nativeElement.value;
    if (!this.pattern) {
      this.element.nativeElement.value = initalValue.replace(Constants.DIRECTIVE_NAME_WITH_DOT_ALPHABETS_REGEX, '');
    } else {
      this.element.nativeElement.value = initalValue.replace(this.pattern, '');
    }

    if (initalValue !== this.element.nativeElement.value) {
      this.control.control.setValue(this.element.nativeElement.value);
      event.stopPropagation();
    }
  }
}
